















































import { defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api';
import { SfProductCard } from '~/components';
import {useImage, useUiState} from '~/composables';
import type { Product } from '~/modules/catalog/product/types';
import transparentPlaceholder from '~/styles/images/transparent_placeholder.svg';

import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';

export default defineComponent({
  name: 'CategoryProductGrid',
  components: {
    CategoryProductPrice,
    SfProductCard,
    SkeletonLoader,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    isQuickShop: [Boolean, Number],
    isClothingAndFootwear: Boolean,
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart', 'visibilityChanged', 'quick-shop-open'],
  setup(props) {
    const { imageSizes: { productCard: imageSize } } = useImage();
    const { isCategoryGridView } = useUiState();
    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);

    watch(products, () => {
      if (props.isClothingAndFootwear) {
        productsWithCommonProductCardProps.value.map((product, index) => {
          if (index === 0 || index % 6 === 0 || (index + 1) % 6 === 0) {
            product.commonProps.image = [product.horizontal_image.url, product.horizontal_image_hover.url]
          } else {
            product.commonProps.image = [product.vertical_image.url, product.vertical_image_hover.url]
          }
        })
      }
    })

    return {
      imageSize,
      transparentPlaceholder,
      productsWithCommonProductCardProps,
      isCategoryGridView
    };
  },
});
